import { clsx } from "@trydig/ui";
import { CartItem } from "~/components/ui/CartItem";
import { useCart } from "~/lib/hooks/useCart";
import styles from "./CartItems.module.css";

export interface CartItemsProps {
	isCheckout?: boolean;
}

export const CartItems = ({ isCheckout }: CartItemsProps) => {
	const { groupItems } = useCart();

	return (
		<div className={clsx(styles["groups-wrapper"], isCheckout && styles.isCheckout)}>
			{groupItems?.map((group) => {
				if (group.id === "default")
					return group.items?.map((item, i) => {
						return <CartItem item={item} key={i} />;
					});

				return (
					<div key={group.id} className={styles["group-container"]}>
						{group.items?.map((item, i) => {
							return (
								<CartItem
									item={item}
									key={i}
									groupItemsIds={group.itemsIds.filter(Boolean) as string[]}
								/>
							);
						})}
					</div>
				);
			})}
		</div>
	);
};
